"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Defines the style of a confirm dialog button.
 */
var AddinConfirmButtonStyle;
(function (AddinConfirmButtonStyle) {
    // The button represents a "secondary" action (default)
    AddinConfirmButtonStyle[AddinConfirmButtonStyle["Default"] = 0] = "Default";
    // The button represents a "primary" action
    AddinConfirmButtonStyle[AddinConfirmButtonStyle["Primary"] = 1] = "Primary";
    // The button represents a "link" action, often used
    // to trigger an action to cancel/close a confirm dialog
    AddinConfirmButtonStyle[AddinConfirmButtonStyle["Link"] = 2] = "Link";
})(AddinConfirmButtonStyle = exports.AddinConfirmButtonStyle || (exports.AddinConfirmButtonStyle = {}));
//# sourceMappingURL=addin-confirm-button-style.js.map